// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraPictureBoxTemplate from '@front/templates/TerceraPictureBoxTemplate.html';
import { Control } from './Control';
export class TerceraPictureBox extends Control {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.on('imageLoaded', this.onImageLoaded);
        this.on('imageNotLoaded', this.onImageNotLoaded);
        this.observe('width height', this.onSizeChanged);
    }
    onSizeChanged() {
        this.fire(TerceraPictureBoxEvents.SizeChanged);
    }
    onImageLoaded() {
        void this.set('imageLoaded', true);
        if (this.get('useCustomSize'))
            return;
        const img = this.find('img');
        if (isNullOrUndefined(img))
            return;
        void this.set({
            width: img.naturalWidth,
            height: img.naturalHeight
        });
    }
    onImageNotLoaded() {
        void this.set('imageLoaded', false);
    }
}
export var TerceraPictureBoxEvents;
(function (TerceraPictureBoxEvents) {
    TerceraPictureBoxEvents["SizeChanged"] = "sizeChanged";
})(TerceraPictureBoxEvents || (TerceraPictureBoxEvents = {}));
Control.extendWith(TerceraPictureBox, {
    template: TerceraPictureBoxTemplate,
    data: function () {
        return {
            imageUrl: '',
            useCustomSize: true,
            imageLoaded: false,
            component_style: 'js-picture-box'
        };
    }
});
